import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight, FiStar } = FiIcons;
const bookingUrl = 'https://optmise.com';

function Testimonial({ onNavigate }) {
  return (
    <section className="testimonial-section panel-section" id="testimonial">
      <motion.div className="quote-card" whileHover={{ rotate: -0.5 }}>
        <div className="quote-rating">
          {[1, 2, 3, 4, 5].map((star) => <SafeIcon icon={FiStar} key={star} />)}
        </div>
        <blockquote>
          “Growth Sparrow turned a messy appointment process into the smoothest part of our customer journey.”
        </blockquote>
        <div className="quote-person">
          <img src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=120&q=80" alt="Dr. Elena Brooks" />
          <div><strong>Dr. Elena Brooks</strong><span>Founder, Wellwise Clinic</span></div>
        </div>
      </motion.div>
      <div className="results-card">
        <span className="section-index">03 / Results</span>
        <h2>More bookings.<br />Less <em>busywork.</em></h2>
        <div className="results">
          <div><strong>42%</strong><span>fewer no-shows</span></div>
          <div><strong>8.5h</strong><span>saved each week</span></div>
        </div>
        <button className="dark-button" type="button" onClick={() => { window.open(bookingUrl, '_blank', 'noopener,noreferrer'); }}>
          Start your story <SafeIcon icon={FiArrowUpRight} />
        </button>
      </div>
    </section>
  );
}

export default Testimonial;